import { Ability } from '@casl/ability'
import { createContextualCan } from '@casl/react'
import { createContext } from 'react'

import { EUserRole } from '../../constants/user'
import { IUser } from '../../types/user'

export default function defineAbilityFor(user?: IUser) {
  if (!user) {
    return new Ability([])
  }

  if (isAdmin(user) || isMerchant(user)) {
    return new Ability([
      {
        action: 'manage',
        subject: 'all',
      },
    ])
  }

  const filteredAbilities = (user.abilities || []).map((rule: any) => {
    // Remove the fields property if it's an empty array
    if (rule.fields && rule.fields.length === 0) {
      const { fields, ...rest } = rule
      return rest
    }
    return rule
  })

  if (isNewFeature(user)) {
    return new Ability([
      ...filteredAbilities,
      {
        action: 'manage',
        subject: 'newFeature',
      },
    ])
  }

  return new Ability(filteredAbilities)

  // return new Ability(user.abilities || [])
}

export const AbilityContext = createContext(defineAbilityFor())
export const Can = createContextualCan(AbilityContext.Consumer)

export const isUser = (user: IUser) => {
  return user.roles?.includes(EUserRole.USER)
}

export const isAdmin = (user: IUser) => {
  return user.roles?.includes(EUserRole.ADMIN)
}

export const isSuperAdmin = (user: IUser) => {
  return user.roles?.includes(EUserRole.SUPER_ADMIN)
}

export const isMerchant = (user: IUser) => {
  return user.roles?.includes(EUserRole.MERCHANT)
}

export const isHead = (user: IUser) => {
  return user.roles?.includes(EUserRole.HEAD)
}

export const isNewFeature = (user: IUser) => {
  return user.roles?.includes(EUserRole.NEW_FEATURE)
}

export const isNotUser = (user: IUser | any) => {
  return user.roles?.some((role: any) =>
    [
      EUserRole.ADMIN,
      EUserRole.SUPER_ADMIN,
      EUserRole.MERCHANT,
      EUserRole.HEAD,
    ].includes(role as EUserRole),
  )
}
